module.exports = __webpack_public_path__ + "static/media/dashboard_background.7903398f.png";